import { useCallback, useMemo, useState } from "react";
import { Form } from "antd";

export default function useSupplierForm({ create, update, reload, message }) {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const editingId = editing?._id ?? editing?.id ?? null;

  const title = useMemo(
    () => (editingId ? `Редагування: ${editing?.name || ""}` : "Новий постачальник"),
    [editingId, editing?.name]
  );

  const onCreate = useCallback(() => {
    setEditing(null);
    form.setFieldsValue({ name: "", phone: "", country: "", note: "" });
    setOpen(true);
  }, [form]);

  const onEdit = useCallback((item) => {
    setEditing(item ?? null);
    form.setFieldsValue({
      name: item?.name || "",
      phone: item?.phone || "",
      country: item?.country || "",
      note: item?.note || "",
    });
    setOpen(true);
  }, [form]);

  const onClose = useCallback(() => {
    if (submitting) return;
    setOpen(false);
  }, [submitting]);

  const onSubmit = useCallback(async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const values = await form.validateFields();
      if (editingId) {
        await update(editingId, values);
        message?.success?.("Зміни збережено");
      } else {
        await create(values);
        message?.success?.("Постачальника додано");
      }
      setOpen(false);
      setEditing(null);
      await reload();
    } catch (e) {
      if (e?.response?.status === 409) {
        message?.error?.("Постачальник з такою назвою вже існує");
      }
    } finally {
      setSubmitting(false);
    }
  }, [submitting, form, editingId, update, create, reload, message]);

  return { form, open, title, onCreate, onEdit, onClose, onSubmit, submitting, editingId };
}
